interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export function LoadingSpinner({
  message = "Loading...",
  className = "",
}: LoadingSpinnerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`min-h-screen bg-background flex items-center justify-center ${className}`}
    >
      <div className="text-center">
        <div
          aria-hidden="true"
          className="w-10 h-10 border-[3px] border-primary/20 border-t-primary rounded-full animate-spin mx-auto mb-4"
        />
        <div className="text-sm font-semibold text-muted-foreground">
          {message}
        </div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
